import { twMerge } from "tailwind-merge";

const CatWithChildren = ({ cat, main_active, active_id }) => {
  const active = cat?.term_id == active_id;

  return (
    <li className={"mb-1 list-none"}>
      <a
        href={cat?.permalink}
        title={cat?.name}
        className={twMerge(
          "flex justify-between px-3 items-center h-8 rounded-5 mb-1 text-sm w-fit",
          "hover:bg-active-background transition-all duration-300",
          active && "bg-active-background no-underline font-bold",
        )}
      >
        {cat?.name}
      </a>
      {cat?.children?.length > 0 && main_active && (
        <ul className="ml-6">
          {cat?.children?.map((child, idx) => {
            return (
              <CatWithChildren
                key={idx}
                cat={child}
                active_id={active_id}
                main_active={main_active}
              />
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default CatWithChildren;
